import { render, staticRenderFns } from "./ExpandPublishmentButton.vue?vue&type=template&id=94cbf7b2&"
import script from "./ExpandPublishmentButton.vue?vue&type=script&lang=ts&"
export * from "./ExpandPublishmentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports